module.exports = __webpack_public_path__ + "static/media/applicationsicon.01f185cf.svg";